/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { RequestBuilder } from '../../request-builder';
import { StrictHttpResponse } from '../../strict-http-response';

import { SearchLotResultDto } from '../../models/search-lot-result-dto';

export interface SearchForLotByStreet$Params {
  lot: string;
  street_name: string;
  street_type?: string;
  street_suffix?: string;
  locality?: string;
}

export function searchForLotByStreet(
  http: HttpClient,
  rootUrl: string,
  params: SearchForLotByStreet$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<SearchLotResultDto>> {
  const rb = new RequestBuilder(rootUrl, searchForLotByStreet.PATH, 'get');
  if (params) {
    rb.query('lot', params.lot, {});
    rb.query('street_name', params.street_name, {});
    rb.query('street_type', params.street_type, {});
    rb.query('street_suffix', params.street_suffix, {});
    rb.query('locality', params.locality, {});
  }

  return http
    .request(
      rb.build({ responseType: 'json', accept: 'application/json', context }),
    )
    .pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SearchLotResultDto>;
      }),
    );
}

searchForLotByStreet.PATH = '/search/lot/by_street';
